export enum PaymentMethodsStaticActionType {
  Delete = 'delete',
}
